import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';

const CREDS = { user: 'admin', pass: 'ZingaAdmin@2024' };

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    setTimeout(() => {
      if (username.trim() === CREDS.user && password === CREDS.pass) {
        sessionStorage.setItem('zinga_admin', 'yes');
        navigate('/admin/dashboard', { replace: true });
      } else {
        setError('Invalid username or password.');
        setLoading(false);
      }
    }, 600);
  };

  return (
    <div className='adm-login-page'>
      <div className='adm-login-card'>
        <div className='adm-login-brand'>
          <div className='adm-login-logo'>Z</div>
          <h1 className='adm-login-title'>ZINGA Admin</h1>
          <p className='adm-login-sub'>John Galt Zinga Technologies</p>
        </div>

        <form className='adm-login-form' onSubmit={handleSubmit}>
          {error && <div className='adm-login-error'>{error}</div>}

          <div className='adm-login-group'>
            <label className='adm-login-label'>Username</label>
            <input
              type='text'
              className='adm-login-input'
              placeholder='admin'
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoFocus
              required
            />
          </div>

          <div className='adm-login-group'>
            <label className='adm-login-label'>Password</label>
            <input
              type='password'
              className='adm-login-input'
              placeholder='Password'
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>

          <button type='submit' className='adm-login-btn' disabled={loading}>
            {loading ? 'Logging in...' : 'Login to Admin'}
          </button>
        </form>

        <a href='/' className='adm-login-back'>← Back to Website</a>
      </div>
    </div>
  );
};

export default AdminLogin;
